// If development, use localhost. Otherwise, use deployed API.
export const apiBaseUrl = process.env.NODE_ENV === 'development' ? 'https://localhost:7058' : 'https://api.videolibrary.s.bristow.me';
export const msalClientId = "ba423dbd-d265-48a2-bf9b-277268ce3cc1";
export const accessAsUserScope = `api://${msalClientId}/access_as_user`;
export const uncategorizedText = 'Uncategorized';
